import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '恋爱漫画', href: '/category/romance' },
      { label: '奇幻漫画', href: '/category/fantasy' },
      { label: '动作漫画', href: '/category/action' },
      { label: '悬疑漫画', href: '/category/thriller' },
      { label: '搞笑漫画', href: '/category/comedy' },
      { label: '剧情漫画', href: '/category/drama' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户口碑', href: '/about#testimonials' },
      { label: '发展历程', href: '/about#milestones' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '/#faq' },
      { label: '阅读指南', href: '/#faq' },
      { label: '版权声明', href: '/about' },
      { label: '意见反馈', href: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span
              className="text-2xl font-bold whitespace-nowrap"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              <span className="text-primary-400">韩漫</span>
              <span className="text-background-50">天堂</span>
            </span>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              您的韩国漫画在线阅读首选平台。
              <br />
              海量资源，免费阅读，每日更新。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; 2019 - 2026 韩漫天堂 HanManTianTang.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-sm text-background-400">
            <span>京ICP备2024XXXXXXXX号</span>
            <span className="hidden sm:inline">|</span>
            <span>京公网安备 1101050203XXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}